/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76178Req {
  
  /** 任务节点id */
  bizNo?: string;
  /** 任务名称 */
  newTaskName?: string;
  /** 开始时间 */
  startTime?: string;
  /** 结束时间 */
  endTime?: string;
  /** 执行人 */
  exuteUserNo?: string;
};



export type API76178Res = {};


// 接口函数 76178 修改任务节点

export interface IUsePostAPI76178Return {
  /** 修改任务节点: 接口请求状态 */
  isAPI76178Loading: boolean;
  /** 修改任务节点: 接口请求返回数据 */
  dataAPI76178: API76178Res;
  /**  修改任务节点: 接口数据请求方法 */
  fetchAPI76178Data: (inputs: API76178Req, config?: YWRequestConfig) => Promise<API76178Res>;
  /** 修改任务节点: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76178 = ():IUsePostAPI76178Return => {
  let isMount = true;
  const [isAPI76178Loading, setIsAPI76178Loading] = useState(false);
  const [dataAPI76178, setDataAPI76178] = useState<API76178Res>({} as API76178Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/edit/node`;

  const fetchAPI76178Data = async (inputs: API76178Req, config?: YWRequestConfig): Promise<API76178Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76178Req>) || {}) as API76178Req;
    
  
    if ( isMount ) {
      setIsAPI76178Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76178Res>(`${basePath}/yoaichat-web/task/instance/edit/node`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76178(res || {} as API76178Res);
        setIsAPI76178Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76178Loading(false);
      }
      return false as unknown as API76178Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76178Loading,
    dataAPI76178,
    fetchAPI76178Data,
    requestUrl,
  }
}

